export const news = {
  newsPageTitle: "Promotions & News",
  newsPageSubtitle: "Latest promotions, tournaments and updates",
  newsNew: "New",
  newsReadMore: "Read more",
  newsLoadMore: "Show more news",
  articleBadgePromo: "Promotion",
  articleNotFound: "Article not found",
  articleBackToNews: "Back to News",
  articleCtaTitle: "Ready to play?",
  articleCtaSubtitle: "Take advantage of this promotion and start winning now",
  articleCtaPlay: "Play now",
  articleCtaMore: "View more promotions",
  articleRelated: "More news",
  articleViewAll: "View all",
};
